import { ChevronDown } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PanduanDaftarQrisku() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [activeIndex, setActiveIndex] = useState(null);

  const data = [
    {
      title: "Berapa lama proses pengajuan QRIS ?",
      content:
        "Proses pembuatan 2 – 6 hari kerja atau menyesuaikan antrian pembuatan QRIS",
    },
    {
      title: "Apakah ada biaya pembuatan QRIS ?",
      content:
        "Ya, biaya admin QRIS mengikuti peraturan dari Bank Nobu, yang akan kami informasikan setiap terdapat perubahan aturan",
    },
    {
      title: "Apakah seluruh mitra Kenzie Komunika bisa membuat QRIS?",
      content:
        "Ya, seluruh mitra Kenzie Komunika dapat mengajukan pembuatan QRIS",
    },
    {
      title: "Dimanakah saldo pencairan dana QRIS saya masuk ?",
      content:
        "Dana QRIS mitra Kenzie Komunika menambah saldo agen di aplikasi Kenzie Komunika",
    },
    {
      title: "Berapa lama pencairan dana ke saldo agen di aplikasi Kenzie Komunika ?",
      content:
        "Pencairan dana otomatis masuk ke saldo di aplikasi Kenzie Komunika saat pelanggan bertransaksi menggunakan QRIS.",
    },
    {
      title: "Apakah Kenzie Komunika akan mendapatkan keuntungan dari mitra yang membuat QRIS ?",
      content:
        "Perusahaan tidak mendapatkan keuntungan materil apapun dari proses pembuatan QRIS. Perusahaan sebagai penyedia layanan aplikasi Kenzie Komunika hanya membantu memberikan fasilitas kepada mitra Kenzie Komunika untuk memberi kemudahan dalam berniaga dan bertransaksi menggunakan Kenzie Komunika. Dari fasilitas tersebut mitra Kenzie Komunika dapat meningkatkan penjualan, dan mempermudah transaksi jual beli tanpa uang tunai (cashless)",
    },
  ];

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [sectionHero, setSectionHero] = useState({
      title: "",
      page: "",
      description: "",
      image: "", 
    });

  const fetchSectionHero = async () => {
        
      try {
          const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}api/sectionhero/panduandaftar`
          );
  
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
          const json = await res.json();
          setSectionHero(json.data[0] || []);
  
      } catch (err) {
          console.error("Fetch Pc error:", err);
      }
    };
    
    useEffect(() => {
      fetchSectionHero();
    }, []);  


  return (
    <div className="min-h-screen bg-slate-400/95  text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="relative
          h-[32vh] md:h-[40vh] lg:h-[45vh]
          overflow-hidden
          flex items-center justify-center
          bg-white"
      >
        <div className="absolute inset-0">
          <img
            src={`${process.env.REACT_APP_BASE_URL}uploads/images/${sectionHero.image}`}
            alt="background"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-slate-950/60"></div>

          {/* Gradient Glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-white"></div>

          {/* Optional Glow Accent */}
          <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
        </div>        

        <div className={`
            relative z-10
            px-6
            text-center
            max-w-5xl
            mx-auto
            translate-y-[2vh]
            transition-all duration-1000
            ${
              visibleSections.has("header")
                ? "opacity-100"
                : "opacity-0 translate-y-[5vh]"
            }
          `}>
          <h1 className="
              font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-red-400 via-white to-blue-800
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]">
            {sectionHero.page}
          </h1>
          <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>
          <p className="text-xl mx-auto
            max-w-xs sm:max-w-2xl text-white
            leading-relaxed
            text-[clamp(.95rem,1.8vw,1.15rem)]">
            {sectionHero.description}
          </p>
        </div>
      </section>

      {/* Filter Section */}
      {/* <section 
        data-section="filter"
        className="py-8 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('filter') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-red-600 text-white shadow-lg shadow-blue-500/50'
                    : 'bg-slate-800 text-gray-400 hover:text-white hover:bg-slate-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section> */}

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-10 md:py-16  bg-white relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('projects') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-col lg:flex-row gap-6 md:gap-8 items-center justify-center">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="/images/panduan/qrisku.png"
                className="w-full max-w-sm md:max-w-xl object-contain transition duration-300 md:hover:scale-110"
              />
            </div>
            <div className="w-full lg:w-1/2 p-2 md:p-4">
              <h1 className="text-lg md:text-2xl font-semibold mb-4 text-slate-900">
                Daftarkan outlet / toko kamu dengan pembayaran via QRIS di Kenzie Komunika APK...
              </h1>

              <ol className="list-decimal ml-5 md:ml-8 text-gray-400 text-sm md:text-base space-y-2">
                <li><b className="text-slate-700">Gratis</b> : Pembuatan QRIS GRATIS</li>
                <li><b className="text-slate-700">Meningkatkan Penjualan</b></li>
                <li><b className="text-slate-700">Lebih Praktis</b></li>
                <li><b className="text-slate-700">Lebih Efisien</b></li>
                <li><b className="text-slate-700">Keamanan Transaksi</b></li>
                <li><b className="text-slate-700">Meningkatkan Branding</b></li>
              </ol>
            </div>

          </div>
        </div>
        <div className={`relative py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-3xl md:text-3xl text-center  font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Persyaratan Daftar QRISku
          </h1>
          <div className="flex flex-col lg:flex-row gap-6 md:gap-8 items-center justify-center">
            <div className="w-full lg:w-1/2">
              <ol className="list-decimal ml-5 md:ml-8 text-slate-900 text-sm md:text-base space-y-2">
                <li>Foto atau scan KTP</li>
                <li>
                  Data pribadi:
                  <ul className="list-disc ml-5 mt-2 space-y-1">
                    <li>Agen ID</li>
                    <li>NIK</li>
                    <li>Nama outlet</li>
                    <li>Alamat</li>
                  </ul>
                </li>
                <li>Terdaftar di Kenzie Komunika</li>
              </ol>
            </div>
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="/images/panduan/register.png"
                className="w-full max-w-sm md:max-w-xl object-contain transition duration-300 md:hover:scale-110"
              />
            </div>
          </div>
        </div>
        <div className={`relative py-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-3xl md:text-3xl text-center  font-bold mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
            Proses Pendaftaran QRISku
          </h1>
          <div className="absolute inset-0">
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
          </div>
          <div className="flex flex-col lg:flex-row gap-6 md:gap-8 items-center justify-center">
            <div className="w-full lg:w-1/2 flex justify-center md:group-hover:scale-110 transition">
              <img
                src="/images/panduan/register2.png"
                className="w-full max-w-sm md:max-w-xl object-contain"
              />
            </div>

            <div className="w-full lg:w-1/2 p-2 md:p-4">
              <h1 className="text-lg md:text-2xl font-bold mb-4 text-slate-900">
                Proses pendaftaran:
              </h1>

              <ol className="list-decimal ml-5 md:ml-8 text-slate-900 text-sm md:text-base space-y-2 mb-4">
                <li>Siapkan persyaratan</li>
                <li>Isi form</li>
                <li>Verifikasi</li>
                <li>QRIS selesai</li>
              </ol>

              <h1 className="text-lg md:text-2xl font-bold mb-3 text-slate-900">
                Catatan:
              </h1>

              <ul className="list-disc ml-5 text-slate-900 text-sm md:text-base space-y-1">
                <li>Tidak pernah meminta OTP</li>
                <li>GRATIS tanpa biaya</li>
                <li>Sesuai kebijakan Bank Indonesia</li>
              </ul>
            </div>
            
          </div>
        </div>

        <div className={`relative py-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-3xl md:text-3xl text-center  font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Frequently Asked Questions
          </h1>
          <div className="flex flex-row gap-8 items-center justify-center">
            <div className="max-w-2xl mx-auto space-y-4">
              {data.map((item, index) => (
                <div
                  key={index}
                  className="border border-slate-700 rounded-2xl overflow-hidden bg-gradient-to-r from-red-500 to-[#3E3274]"
                >
                  {/* Header */}
                  <button
                    onClick={() => toggle(index)}
                    className="w-full flex justify-between items-center px-6 py-4 text-left"
                  >
                    <span className="text-lg font-semibold text-white">
                      {item.title}
                    </span>
                    <ChevronDown
                      className={`transition-transform duration-300 ${
                        activeIndex === index ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {/* Content */}
                  <div
                    className={`grid transition-all duration-500 ease-in-out ${
                      activeIndex === index
                        ? "grid-rows-[1fr] opacity-100"
                        : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="px-6 pb-4 text-white">
                        {item.content}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-white relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-red-500/20 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent leading-tight">
            Ayo bergabung menjadi mitra Kami!
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-slate-700 mb-6 md:mb-8 leading-relaxed">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>
          <Link 
            to="https://play.google.com/store/apps/details?id=com.otoreport.kenziekomunika" target="_blank"
            className="inline-block px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 text-white"
          >
            Mulai mendaftar
          </Link>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
